import { DEFAULT_SHARED_PARAMETERS } from '../../constants/defaultSharedParameters';
import { parseSharedParameterFile } from '../../services/sharedParameterParser';
import type { SharedParameter } from '../../types/sharedParameter.types';

/**
 * Parsed view of the shipped PipeEX shared parameter file.
 *
 * The shared-parameter store only reflects the file the user loaded (and only
 * after hydration), so consumers that need definitions for known PipeEX
 * parameters — readiness promotion, project binding creation — must not rely
 * on the store alone. The embedded file is always available and is the
 * authoritative source for shipped parameters regardless of which file mode
 * the wizard is in.
 */
let cachedDefaultParameters: SharedParameter[] | null = null;

export function getDefaultSharedParameters(): SharedParameter[] {
  if (cachedDefaultParameters === null) {
    cachedDefaultParameters = parseSharedParameterFile(DEFAULT_SHARED_PARAMETERS).parameters;
  }

  return cachedDefaultParameters;
}

/**
 * Combines the currently loaded (possibly custom) shared parameters with the
 * shipped defaults. Store-loaded entries win on name conflicts; the defaults
 * only fill in names the loaded file does not define.
 */
export function mergeWithDefaultSharedParameters(
  storeParameters: SharedParameter[]
): SharedParameter[] {
  const storeNames = new Set(
    storeParameters.map((parameter) => parameter.name.trim().toLowerCase())
  );

  return [
    ...getDefaultSharedParameters().filter(
      (parameter) => !storeNames.has(parameter.name.trim().toLowerCase())
    ),
    ...storeParameters,
  ];
}
